import type { SectionProps, SectionsInstitutionalCards } from "../../../types";
import { institutionalCardsVariant } from "./institutional-cards.variants";

export type UseInstitutionalCardsProps =
  SectionProps<SectionsInstitutionalCards>;

export const useInstitutionalCards = (props: UseInstitutionalCardsProps) => {
  const { className = "", sectionName, data } = props;
  const { theme = "dark" } = data;

  const styles = institutionalCardsVariant({ theme });

  return {
    sectionName,
    className,
    styles,
    data,
  };
};
